/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';

import { convertToJson } from '../../../../Common/utils';
import { getCurrentAggregatorPayloadDetails } from '../../../selectors';

const useAggregatorPayloadTab = () => {
  const aggregatorTab = useSelector(getCurrentAggregatorPayloadDetails);
  const aggregatorPayloadInfo = convertToJson(aggregatorTab);

  return aggregatorPayloadInfo;
};

export default useAggregatorPayloadTab;
